import { BaseSopOperation } from "./_Base";
import { InputCloneMode } from "../../../engine/poly/InputCloneMode";
import { PointLight } from "three";
import { isBooleanTrue } from "../../../core/BooleanValue";
import { Group } from "three";
import { CorePointLightHelper, DEFAULT_POINT_LIGHT_PARAMS } from "../../../core/lights/PointLight";
export class PointLightSopOperation extends BaseSopOperation {
  static type() {
    return "pointLight";
  }
  cook(input_contents, params) {
    var _a;
    const light = this.createLight();
    const nodeName = (_a = this._node) == null ? void 0 : _a.name();
    if (nodeName) {
      light.name = `PointLight_${nodeName}`;
    }
    this.updateLightParams(light, params);
    this.updateShadowParams(light, params);
    if (isBooleanTrue(params.showHelper)) {
      const group = new Group();
      if (nodeName) {
        group.name = `PointLightGroup_${nodeName}`;
      }
      group.add(light);
      const helper = this._createHelper(light, params);
      if (helper) {
        group.add(helper);
        if (nodeName) {
          helper.name = `PointLightHelper_${nodeName}`;
        }
      }
      return this.createCoreGroupFromObjects([group]);
    } else {
      return this.createCoreGroupFromObjects([light]);
    }
  }
  _createHelper(light, params) {
    this._helper = this._helper || new CorePointLightHelper();
    return this._helper.createAndBuildObject({ helperSize: params.helperSize, light });
  }
  createLight() {
    const light = new PointLight();
    light.matrixAutoUpdate = false;
    light.castShadow = true;
    light.shadow.bias = -1e-3;
    light.shadow.mapSize.x = 1024;
    light.shadow.mapSize.y = 1024;
    light.shadow.camera.near = 0.1;
    return light;
  }
  updateLightParams(light, params) {
    light.color = params.color;
    light.intensity = params.intensity;
    light.decay = params.decay;
    light.distance = params.distance;
  }
  updateShadowParams(light, params) {
    light.castShadow = isBooleanTrue(params.castShadow);
    light.shadow.autoUpdate = isBooleanTrue(params.shadowAutoUpdate);
    light.shadow.needsUpdate = light.shadow.autoUpdate || isBooleanTrue(params.shadowUpdateOnNextRender);
    light.shadow.mapSize.copy(params.shadowRes);
    light.shadow.camera.near = params.shadowNear;
    light.shadow.camera.far = params.shadowFar;
    light.shadow.bias = params.shadowBias;
    light.shadow.camera.updateProjectionMatrix();
  }
}
PointLightSopOperation.DEFAULT_PARAMS = DEFAULT_POINT_LIGHT_PARAMS;
PointLightSopOperation.INPUT_CLONED_STATE = InputCloneMode.NEVER;
